import {remCalc} from '../_utils'

const spacing = {
    micro: {
        base: remCalc(2),
        md: remCalc(2),
        lg: remCalc(2),
        xl: remCalc(2),
    },
    xxxsmall: {
        base: remCalc(4),
        md: remCalc(4),
        lg: remCalc(4),
        xl: remCalc(4),
    },
    'xxxsmall-1': {
        base: remCalc(6),
        md: remCalc(6),
        lg: remCalc(6),
        xl: remCalc(6),
    },
    xxsmall: {
        base: remCalc(6),
        md: remCalc(6),
        lg: remCalc(8),
        xl: remCalc(8),
    },
    'xxsmall-1': {
        base: remCalc(8),
        md: remCalc(8),
        lg: remCalc(12),
        xl: remCalc(12),
    },
    xsmall: {
        base: remCalc(12),
        md: remCalc(12),
        lg: remCalc(16),
        xl: remCalc(16),
    },
    'xsmall-1': {
        base: remCalc(16),
        md: remCalc(16),
        lg: remCalc(20),
        xl: remCalc(20),
    },
    small: {
        base: remCalc(20),
        md: remCalc(20),
        lg: remCalc(24),
        xl: remCalc(24),
    },
    'small-1': {
        base: remCalc(24),
        md: remCalc(24),
        lg: remCalc(32),
        xl: remCalc(32),
    },
    medium: {
        base: remCalc(32),
        md: remCalc(32),
        lg: remCalc(40),
        xl: remCalc(40),
    },
    'medium-1': {
        base: remCalc(40),
        md: remCalc(40),
        lg: remCalc(48),
        xl: remCalc(48),
    },
    'medium-2': {
        base: remCalc(48),
        md: remCalc(48),
        lg: remCalc(64),
        xl: remCalc(64),
    },
    'medium-3': {
        base: remCalc(56),
        md: remCalc(56),
        lg: remCalc(80),
        xl: remCalc(80),
    },
    large: {
        base: remCalc(64),
        md: remCalc(64),
        lg: remCalc(80),
        xl: remCalc(96),
    },
    xlarge: {
        base: remCalc(80),
        md: remCalc(80),
        lg: remCalc(96),
        xl: remCalc(128),
    },

    page: {
        base: remCalc(12),
        md: remCalc(12),
        lg: remCalc(40),
        xl: remCalc(40),
        '2xl': remCalc(40),
    },
}

export default spacing
